import React, { useEffect, useState, useRef } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { useOutsideClick } from '@chakra-ui/hooks';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { SelectInputItemProps } from 'types/SelectInputItemProps';
import { color } from 'styles/pallete';
import useWindowSize from 'hooks/useWindowSize';
import QuestionBox from 'components/QuestionBox';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface SelectInputProps {
	id?: string;
	label?: string;
	withLabel?: boolean;
	getValue: any; //função setState
	list: SelectInputItemProps[];
	error?: boolean;
	messagemError?: string;
	emptyInput?: boolean;
	initialValue?: SelectInputItemProps | string; // passe um objeto do tipo Select2ListItem ou uma string vazia para nao bugar
	minWidth?: number;
	messageQuestionBox?: string;
	diseable?: boolean;
	isHide?: boolean;
	dropdownPlacement?: 'top' | 'bottom';
}

export default function SelectInput({
	id,
	label = 'selectInput.passLabel',
	withLabel = true, // se true fica sem a label
	getValue = function (value: any) {
		return value;
	},
	list,
	error = false,
	messagemError = 'selectInput.anyError',
	emptyInput = false, // se true, input é opcional e o retorno sera undefined
	initialValue = '',
	minWidth = 0,
	messageQuestionBox = '',
	diseable = false,
	isHide = false,
	dropdownPlacement = 'bottom'
}: SelectInputProps) {
	const { t }: UseTranslationProps = useTranslation();
	const modal = useRef(null);
	const [value, setValue] = useState<SelectInputItemProps | string>(
		initialValue
	);
	const [optionsVisiabel, setOptionsVisiabel] = useState(false);
	const [alredyUseInitialValue, setAlredyUseInitialValue] = useState(false);

	const screen = useWindowSize();

	useEffect(() => {
		if (typeof value !== 'undefined' && !emptyInput) {
			getValue(value);
		}
	}, [value]);

	// se precisar apagar useEffect abaixo vai bugar o lockscreen que esta na tela de login
	useEffect(() => {
		if (!alredyUseInitialValue && initialValue !== '') {
			setAlredyUseInitialValue(true);
			setValue(initialValue);
		}
	}, [initialValue]);

	useOutsideClick({
		ref: modal,
		handler: () => {
			// acredito q nao é interessante essa funionalidade no mobile
			if (screen.width! > 1000) {
				setOptionsVisiabel(false);
			}
		}
	});

	return (
		<S.inputBox ref={modal} $diseable={diseable} $isHide={isHide}>
			<S.labelAndQuestionBox>
				{withLabel && <p>{t(label)}</p>}
				{messageQuestionBox !== '' && (
					<QuestionBox text={t(messageQuestionBox)} width={2} />
				)}
			</S.labelAndQuestionBox>

			<S.containerOption $minWidth={minWidth}>
				<S.titleContainer
					$diseable={diseable}
					data-testid={id || `btn-toggle-options-${label}`}
					onClick={() => {
						if (!diseable) {
							setOptionsVisiabel(!optionsVisiabel);
						}
					}}
				>
					<span>
						{typeof value === 'string'
							? t('selectInput.select')
							: t(value.option)}{' '}
					</span>
					<MdKeyboardArrowDown
						style={{
							color: color.interface.lightGray,
							fontSize: '20px',
							transform: optionsVisiabel ? 'rotate(180deg)' : 'rotate(0deg)',
							transition: 'all ease .5s'
						}}
					/>
				</S.titleContainer>

				{optionsVisiabel && (
					<S.modalOptions $placement={dropdownPlacement}>
						{list.map((item) => (
							<p
								data-testid={`option.${item.option}`}
								onClick={() => {
									setValue(item);
									setOptionsVisiabel(false);
								}}
								key={item.id}
							>
								{t(item.option)}
							</p>
						))}
					</S.modalOptions>
				)}
			</S.containerOption>

			{error && <S.errorMessage>{t(messagemError)}</S.errorMessage>}
		</S.inputBox>
	);
}
